export default "__VITE_ASSET__CCO_J1e2__"